import { Model } from "./model";
import { Question } from "./question.model";

export class Quiz extends Model {
    id: number;
    brand_id: number;
    country_id: number;
    language_id: number;
    product_id: number;
    brand_logo: string;
    brand_logo_url: string;
    brand_name: string;
    country_name: string;
    created: string;
    description: string;
    image: string;
    image_url: string;
    language_flag: string;
    language_name: string;
    name: string;
    points: number;
    product_name: string;
    product_ref: string;
    published: number;
    questions: Array<Question> | null;
    user_quiz_correct_answers?: number;
    user_quiz_points?: number;
    user_quiz_created?: string;
}


// WEBPACK FOOTER //
// ./src/models/quiz.model.ts